import axios from 'axios';
import { api } from '@/api';

const types = {
    SET_LOCALE: 'SET_LOCALE',
    UPDATE_LOCALE: 'UPDATE_LOCALE',
}

export const state = {
    locale: window.localStorage.getItem('locale') || 'en',
};

export const mutations = {
    [types.SET_LOCALE](state: any, locale: string) {
        state.locale = locale;
        window.localStorage.setItem('locale', locale);
    },
    /* [types.UPDATE_LOCALE](state: any, locale: string) {
        axios.post
        
    } */
}

export const actions = {
    saveLocale({ commit }: any, payload: any ) {
        commit(types.SET_LOCALE, payload)
    },
}

export const getters = {
    locale: ( state: any ) => state.locale
}